import { Divider, Grid, MenuItem } from "@mui/material";
import useApiServices from "api/useApiServices";
import {
  RHFMultiLineTextField,
  RHFRoundedSelect,
  RHFRoundedTextField,
  RHFSwitch,
  RHFUpload,
} from "components/minimal/hook-form";
import { HOST_API } from "config-global";
import { IFormProps } from "types/form-props";

interface AwardFormProps extends IFormProps {}

const AwardForm: React.FC<AwardFormProps> = ({ currentItem, setValue }) => {
  const { useGetListApi } = useApiServices();

  const { data: challengeCategoriesList } = useGetListApi<any>({
    url: `${HOST_API}/api/admin/challenge-categories`,
  });

  return (
    <>
      <Grid item xs={12}>
        <RHFRoundedSelect
          name="awardCategory"
          size="small"
          label="Category"
          disabled={!!currentItem}
        >
          <MenuItem>None</MenuItem>
          <Divider sx={{ borderStyle: "dashed" }} />
          {challengeCategoriesList?.items?.map((item: any) => (
            <MenuItem key={item.id} value={item.id}>
              {item.title}
            </MenuItem>
          ))}
        </RHFRoundedSelect>
      </Grid>
      <Grid item xs={6}>
        <RHFRoundedTextField name="title" label="Title (En)" />
      </Grid>
      <Grid item xs={6}>
        <RHFRoundedTextField name="titleAr" label="Title (Ar)" />
      </Grid>
      <Grid item xs={6}>
        <RHFMultiLineTextField
          name="description"
          label="Description (En)"
          multiline
          rows={4}
        />
      </Grid>
      <Grid item xs={6}>
        <RHFMultiLineTextField
          name="descriptionAr"
          label="Description (Ar)"
          multiline
          rows={4}
        />
      </Grid>
      <Grid item xs={12}>
        <RHFUpload
          name="coverImage"
          onDrop={(acceptedFiles) => {
            const newFile = Object.assign(acceptedFiles[0], {
              preview: URL.createObjectURL(acceptedFiles[0]),
            });
            setValue("coverImage", newFile);
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <RHFSwitch name="published" label="Published" />
      </Grid>
    </>
  );
};

export default AwardForm;
